<div class="vessel-page-section">
    <div class="page-section-title">
        <div>{{ 'vessel.page.mimics.title' | translate }}</div>
        <div class="counter-text">
            {{
                numberOfMimics == 1
                    ? ('vessel.page.mimics.counter.one' | translate)
                    : ('vessel.page.mimics.counter.other' | translate: { num: numberOfMimics })
            }}
        </div>
    </div>

    <div class="mimics-container">
        <div *ngFor="let mimic of sortedMimics; index as i" class="mimic-container" (click)="selectMimic(mimic)">
            <div class="mimic-preview" #svgHost></div>
            <div class="mimic-info">
                <div class="mimic-name">{{ mimic.name }}</div>
                <div class="folder-name">
                    <ng-container *ngIf="mimic.folderName">
                        {{ mimic.folderName }}
                    </ng-container>
                </div>
                <div class="time-text">{{ getFormattedDate(mimic) }}</div>
            </div>
        </div>
    </div>
</div>
